// AdminLoginPage.jsx
import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import {
  AiOutlineEye,
  AiOutlineEyeInvisible,
  AiOutlineMail,
  AiOutlineLock,
  AiOutlineArrowRight,
} from "react-icons/ai";
import axios from "axios";

import "../../../../assets/css/admin/auth/adminlogin/AdminLogin.css";

import AppContext from "../../../../contexts/AppContext";

const AdminLoginPage = () => {
  const navigate = useNavigate();
   const { baseUrl, setAdminToken, setAdmin, regExpChecker, adminAuthToken } = useContext(AppContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    const newErrors = {};

    const emailError = regExpChecker("email", email);
    if (emailError) newErrors.email = emailError;

    const passwordError = regExpChecker("password", password);
    if (passwordError) newErrors.password = passwordError;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const Adminlogin = () => {
    if (!validateForm()) return;

    setLoading(true);

    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);

    axios
      .post(`${baseUrl}/admin/login`, formData, {
        headers: { "Content-Type": "multipart/form-data",
           "Authorization": `Bearer ${adminAuthToken}`
         },
      })
      .then((response) => {
        console.log(response.data);
        if (!response.data.chadmin) {
          setErrors({ form: "Invalid email or password" });
        } else {
          localStorage.setItem(
            "loggedInAdmin",
            JSON.stringify(response.data.chadmin),
          );
          setAdmin(response.data.chadmin);
          setAdminToken(response.data.token);
          navigate("/admin/dashboard");
        }
      })
      .catch((error) => {
        console.log(error);
        setErrors({ form: "Something went wrong. Try again." });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="admin-login-glassmorphism-container">
      {/* Background */}
      <div className="admin-login-background-circles">
        <div className="admin-login-circle admin-login-circle-1"></div>
        <div className="admin-login-circle admin-login-circle-2"></div>
        <div className="admin-login-circle admin-login-circle-3"></div>
        <div className="admin-login-circle admin-login-circle-4"></div>
      </div>

      <Container fluid className="admin-login-page-wrapper">
        <Row className="admin-login-row w-100 g-0 align-items-center">
          {/* LEFT — BRAND SECTION (unchanged) */}
          <Col xl={6} lg={6} md={12} xs={12} className="admin-login-brand-section">
            <div className="admin-login-logo-container">
              <h1 className="admin-login-logo-text">CRAFTHIVE</h1>
              <p className="admin-login-logo-subtitle">Admin Portal</p>
            </div>
            <h2 className="admin-login-main-heading">
              Manage Your Marketplace with Ease
            </h2>
            <p className="admin-login-description-text">
              Oversee sellers, products, orders, and everything that keeps
              CraftHive running smoothly. Sign in to access your admin
              dashboard.
            </p>
          </Col>

          {/* RIGHT — FORM SECTION */}
          <Col xl={6} lg={6} md={12} xs={12} className="admin-login-form-section">
            <div className="admin-login-glass-card">
              <h3 className="admin-login-form-title text-center">
                WELCOME BACK ADMIN
              </h3>
              <p className="admin-login-form-subtitle text-center">
                Login to your admin account
              </p>

              {errors.form && (
                <p style={{ color: "red", fontSize: "14px" }}>{errors.form}</p>
              )}

              <Form
                className="admin-login-form"
                onSubmit={(e) => {
                  e.preventDefault();
                  Adminlogin();
                }}
              >
                {/* Email */}
                <Form.Group className="admin-login-input-group mb-3">
                  <div className="admin-login-input-icon">
                    <AiOutlineMail size={18} />
                  </div>

                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    className="admin-login-glass-input"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      if (errors.email) {
                        setErrors((prev) => ({ ...prev, email: "" }));
                      }
                    }}
                  />
                </Form.Group>

                {errors.email && (
                  <p style={{ color: "red", fontSize: "14px" }}>{errors.email}</p>
                )}

                {/* Password */}
                <Form.Group className="admin-login-input-group mb-3">
                  <div className="admin-login-input-icon">
                    <AiOutlineLock size={18} />
                  </div>

                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Password"
                    className="admin-login-glass-input"
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      if (errors.password) {
                        setErrors((prev) => ({ ...prev, password: "" }));
                      }
                    }}
                  />

                  <button
                    type="button"
                    className="admin-password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <AiOutlineEyeInvisible size={18} />
                    ) : (
                      <AiOutlineEye size={18} />
                    )}
                  </button>
                </Form.Group>

                {errors.password && (
                  <p style={{ color: "red", fontSize: "14px" }}>
                    {errors.password}
                  </p>
                )}

                {/* Submit */}
                <Button
                  type="submit"
                  className="admin-login-button"
                  disabled={loading}
                >
                  {loading ? "Logging in..." : "LOGIN"}
                  {!loading && <AiOutlineArrowRight size={18} />}
                </Button>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AdminLoginPage;